export const AI_MODEL_TYPES = {
    AUDIO: "audio",
    BLOG: "blog",
    CARTEL: "cartel",
    NEWSLETTER: "newsletter",
    PODCAST: "podcast",
    WEBSITE: "website",
    PRESS: "press",
} as const;
